import { Asset } from 'stellar-sdk';

// ScripTee token details
export const SCRIPTEE: Asset = new Asset('SCRIPTEE', 'GCRIHDMU4MEW7RQX5YPWEMAFDJZU4JTZZ6FYZU2TBDYL254TJF6CTWPJ');

// horizon endpoint
export const SERVER_URL = 'https://horizon.stellar.org/';
